/**
 * Mock PublicClientApplication for Docker dev mode.
 *
 * Provides the same interface that the app expects from
 * @azure/msal-browser's PublicClientApplication, but without
 * any network calls to Azure B2C.
 */

const MOCK_ACCOUNT = {
    username: 'dev@local.test',
    name: 'Local Developer',
    localAccountId: 'mock-local-account-id',
    homeAccountId: 'mock-home-account-id',
    environment: 'local',
    tenantId: 'mock-tenant-id',
    idTokenClaims: {
        emails: ['dev@local.test'],
        tfp: 'mock-policy',
        aud: 'mock-client-id',
        iss: 'https://mock-b2c.b2clogin.com/mock-tenant-id/v2.0/',
        exp: Math.floor(Date.now() / 1000) + 86400,
    },
};

/* eslint-disable no-empty-function */
const mockMsalInstance = {
    getActiveAccount: () => MOCK_ACCOUNT,
    getAllAccounts: () => [MOCK_ACCOUNT],
    setActiveAccount: () => { /* no-op */ },

    acquireTokenSilent: async () => ({
        accessToken: 'docker-stub-token',
        account: MOCK_ACCOUNT,
        idTokenClaims: MOCK_ACCOUNT.idTokenClaims,
    }),

    loginRedirect: async () => {
        console.log('[MockMSAL] loginRedirect — no-op in docker mode');
    },
    loginPopup: async () => {
        console.log('[MockMSAL] loginPopup — no-op in docker mode');
        return {};
    },
    logoutRedirect: async (opts) => {
        console.log('[MockMSAL] logoutRedirect — redirecting to', opts?.postLogoutRedirectUri || '/');
        window.location.href = opts?.postLogoutRedirectUri || '/';
    },
    logout: async (opts) => {
        console.log('[MockMSAL] logout — redirecting to', opts?.postLogoutRedirectUri || '/');
        window.location.href = opts?.postLogoutRedirectUri || '/';
    },

    addEventCallback: () => 'mock-callback-id',
    removeEventCallback: () => { /* no-op */ },

    // Needed for MSAL event system
    enableAccountStorageEvents: () => { /* no-op */ },
    disableAccountStorageEvents: () => { /* no-op */ },

    // Handle redirect promise (called internally)
    handleRedirectPromise: async () => null,
    initialize: async () => { /* no-op */ },
};
/* eslint-enable no-empty-function */

export default mockMsalInstance;
